const userBalance = {
    state: {
        namespaced: true,
        userBalance: {

        },
        proxyShopId: '',
        proxyShopName: '',
        proxyCustomerId: '',
        proxyCustomerName: ''
    },
    getters: {
        users: state => {
            return state.userBalance
        }
    },
    mutations: {
        getUserBalance: (state, commit) => {
            const { val, key } = commit;
            state.userBalance[key] = val;
        },
        setProxyShopId(state, payload){
            state.proxyShopId = payload;
        },
        setProxyShopName(state, payload){
            state.proxyShopName = payload;
        },
        setProxyCustomerId(state, payload){
            state.proxyCustomerId = payload;
        },
        setProxyCustomerName(state, payload){
            state.proxyCustomerName = payload;
        }
    }
}
export default userBalance


// WEBPACK FOOTER //
// ./src/store/userBalance.js